<template>
    <div class="row cards-column cursor-pointer" v-if="cards.length === 4">
      <div class="col-4 card-start">
        <router-link
          :to="{
            name: 'ColumnSingle',
            params: { 
                locale: this.locale,
                catergoriaId: cards[0].idCategory,
                categoriaName: cards[0].slugCategory,
                colunaId: cards[0].id,
                colunaName: cards[0].url
              }
          }"
          class="button--more"
        >
          <div class="card bg-light text-white">
            <img :src="cards[0].image" class="card-img" :alt="cards[0].title" :width="isMobile?390:473" :height="isMobile?330:400"  loading="lazy"/>
            <div class="card-img-overlay">
              <div class="card-category">{{ cards[0].nameCategory }}</div>
              <div class="card-title">{{ cards[0].title }}</div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-4 card-middle" v-if="!isMobile">
        <router-link
          :to="{
            name: 'ColumnSingle',
            params: { 
                locale: this.locale,
                catergoriaId: cards[1].idCategory,
                categoriaName: cards[1].slugCategory,
                colunaId: cards[1].id,
                colunaName: cards[1].url
              }
          }"
          class="button--more"
        >        
          <div class="card bg-light text-white">
            <img :src="cards[1].image" class="card-img-middle" :alt="cards[1].title" width="267" height="202" loading="lazy"/>
            <div class="card-img-overlay">
              <div class="card-category">{{ cards[1].nameCategory }}</div>
              <div class="card-title-middle">{{ cards[1].title }}</div>
            </div>
          </div>
        </router-link>
        <router-link
          :to="{
            name: 'ColumnSingle',
            params: { 
                locale: this.locale,
                catergoriaId: cards[2].idCategory,
                categoriaName: cards[2].slugCategory,
                colunaId: cards[2].id,
                colunaName: cards[2].url
              }
          }"
          class="button--more"
        >        
          <div class="card bg-light text-white">
            <img :src="cards[2].image" class="card-img-middle" :alt="cards[2].title" width="267" height="202" loading="lazy"/>
            <div class="card-img-overlay">
              <div class="card-category">{{ cards[2].nameCategory }}</div>
              <div class="card-title-middle">{{ cards[2].title }}</div>
            </div>
          </div>
        </router-link>        
      </div>
      <div class="col-4 card-end" v-if="!isMobile">
        <router-link
          :to="{
            name: 'ColumnSingle',
            params: { 
                locale: this.locale,
                catergoriaId: cards[3].idCategory,
                categoriaName: cards[3].slugCategory,
                colunaId: cards[3].id,
                colunaName: cards[3].url
              }
          }"
          class="button--more"
        >        
          <div class="card bg-light text-white">
            <img :src="cards[3].image" class="card-img" :alt="cards[3].title" :width="isMobile?390:473" :height="isMobile?330:400" loading="lazy"/>
            <div class="card-img-overlay">
              <div class="card-category">{{ cards[3].nameCategory }}</div>
              <div class="card-title">{{ cards[3].title }}</div>
            </div>
          </div>
        </router-link>        
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import { isMobile } from 'views/shared/utils/mobile'

export default defineComponent({
  name: 'ListItensColumn',
  props: ['cards'],
  computed: {
    ...mapState(localeStore, ['locale']),
  },
  data() {
    return {
      isMobile: isMobile(),      
    }
  },

})
</script>
<style scoped>
.row {
  margin-right: -12px;
  margin-left: 0px;
}

.card-img {
  height: 400px;
  object-fit: cover;
  border-radius: 0px;
}

.card-start {
  width: 39%;
}

.card-end {
  width: 39%;
}

.card-middle {
  width: 22%;
}

.card-img-middle {  
  height: 202px;
  padding: 2px;
  top: -2px;
}

.cards-column {
  margin-top: 13px;
}

.card-img-overlay {
  top: unset;
  padding: 10px 10px;
}

.card-title {
  height: 56px;
  color: #FFFFFF;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}


.card-title-middle {
  height: 42px;
  color: #FFFFFF;
  font-family: 'Roboto-Medium';
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
}

.card-category {
  background-color: black;
  padding: 5px 15px;
  font-size: 13px;
  border-radius: 20px;
  width: fit-content;
  color: #FFFFFF;
  font-family: 'Roboto-Regular';
  font-size: 13px;
  letter-spacing: 0;
}


>>>.row>.col,
.row>[class*=col-] {
  padding-right: 1px;
  padding-left: 1px;
}

@media screen and (max-width: 1200px) {
  .card-start {
    width: 36%;
  }

  .card-end {
    width: 36%;
  }

  .card-middle {
    width: 28%;
  }  

  .card-img-middle {  
    width: 100%;
  }  
}

@media screen and (max-width: 769px) {
  .cards-start, .card-end  {
    position: absolute;
  }

  .card-end {
    left: 95%;
  }
  .cards-column .card-middle {
    display: none;
  }

  .cards-column>>>.col-4 {
    width: 100%;
  }
  .card-img-overlay {
    bottom: 0px;
  }  
  .card-img {
    height: 330px;
  }
}
</style>
